<div class="container-fluid inv-box">
  <div class="row inv-container">
    <div class="col-3">
      <h3 [style.color]="mainColor" class="inv-title">Contact list</h3>

      <p class="inv-text">
        Here you can see your current contacts. You can share your projects with these contacts. Please choose whether you
        like to connect to that contact or not.
      </p>

      <p class="inv-text">
        <span class="bold">Please note</span>, if you like to stop sharing a project or end your participation in a
        project, you can do so within the sharing feature on the 'projects page' anytime and for every project
        individually.
      </p>
    </div>

    <div class="col-9 col-md-offset-2 mb-5 spacer spacer-top">
      <h3 class="inv-subtitle">Invite and manage your <span [style.color]="mainColor">sharing</span> contacts</h3>
      <p class="inv-text">
        You can invite new users to your contact list by adding their email address to the 'Invite a new user' field and click on the 'Invite' button. If you like to delete the permission to share projects
        with one of these contacts, please click on the 'delete' button below. You will delete the contact and your
        linked projects will be removed.
      </p>
      <usimweb-table
        [data]="contactsTableSource"
        [columns]="contactsColumnsTable"
        [deleteBtn]="true"
        (deleteEvent)="deleteContact($any($event))">
      </usimweb-table>
      
      <div class="row align-input">
        <div class="col-9">
          <usimweb-form-field
            [label]="'Invite a new user'"
            (change)="email = $any($event)" data-cy="email-input"></usimweb-form-field>
        </div>

        <div class="col-3">
          <usimweb-button text="Invite" (btnClick)="inviteUser()" data-cy="invite-button">Invite</usimweb-button>
        </div>
      </div>
    </div>

    <div class="col-3 mt-5"></div>

    <div class="col-9 col-md-offset-2 mt-5 spacer spacer-top">
      <h3 class="inv-subtitle">Here you can see your <span [style.color]="mainColor">pending</span> contacts</h3>
      <p class="inv-text">
        If you invite contacts over the input field, then you will find them here in the pending list, until the contact
        accepts your invitation.
      </p>

      <usimweb-table
        style="margin-bottom: 15px"
        [data]="pendingTableSource"
        [columns]="pendingColumnsTable"></usimweb-table>
    </div>
  </div>
</div>
